import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../../Api/Api";

export const addTarget = createAsyncThunk(
  "performance/addtarget",
  // categoryId is accepted for backward compatibility with existing callers
  // but no longer sent — the backend derives the category from the bearer
  // token itself (see /category/targets on the API side).
  async ({ formData, categoryId }, { rejectWithValue, getState }) => {
    const { auth } = getState();
    try {
      const response = await axios.post(
        `${baseURL}/category/targets`,
        formData,
        {
          headers: {
            // "Content-Type": "application/json",
            Authorization: `Bearer ${auth?.token}`,
          },
        }
      );

      const data = response.data;
      if (data.error) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      if (error?.response?.data?.error) {
        return rejectWithValue({
          message: error?.response?.data?.error,
        });
      } else if (error?.response?.data?.message) {
        return rejectWithValue({
          message: error?.response?.data?.message,
        });
      }
    }
  }
);
export const updateTarget = createAsyncThunk(
  "performance/updatetarget",
  async ({ formData, id }, { rejectWithValue, getState }) => {
    const { auth } = getState();
    try {
      const response = await axios.patch(
        `${baseURL}/category/targets/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth?.token}`,
          },
        }
      );

      const data = response.data;
      if (data.error) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      if (error?.response?.data?.error) {
        return rejectWithValue({
          message: error?.response?.data?.error,
        });
      } else if (error?.response?.data?.message) {
        return rejectWithValue({
          message: error?.response?.data?.message,
        });
      }
    }
  }
);
export const deleteTargetCat = createAsyncThunk(
  "performance/deleteTarget",
  async (id, { rejectWithValue, getState }) => {
    const { auth } = getState();
    try {
      const response = await axios.delete(
        `${baseURL}/category/targets/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth?.token}`,
          },
        }
      );

      const data = response.data;
      if (data.error) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      if (error?.response?.data?.error) {
        return rejectWithValue({
          message: error?.response?.data?.error,
        });
      } else if (error?.response?.data?.message) {
        return rejectWithValue({
          message: error?.response?.data?.message,
        });
      }
    }
  }
);
export const listTargets = createAsyncThunk(
  "performance/listTargets",
  async ({ id, page = 1, limit = 10 }, { rejectWithValue, getState }) => {
    const { auth } = getState();
    try {
      const response = await axios.get(
        `${baseURL}/category/targets?page=${page}&limit=${limit}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth?.token}`,
          },
        }
      );

      const data = response.data;
      if (data.error) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      if (error?.response?.data?.error) {
        return rejectWithValue({
          message: error?.response?.data?.error,
        });
      } else if (error?.response?.data?.message) {
        return rejectWithValue({
          message: error?.response?.data?.message,
        });
      }
    }
  }
);
export const getTransactions = createAsyncThunk(
  "performance/getTransactions",
  async ({ page = 1, limit = 10 }, { rejectWithValue, getState }) => {
    const { auth } = getState();
    try {
      const response = await axios.get(
        `${baseURL}/category/transactions?page=${page}&limit=${limit}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth?.token}`,
          },
        }
      );

      const data = response.data;
      if (data.error) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      if (error?.response?.data?.error) {
        return rejectWithValue({
          message: error?.response?.data?.error,
        });
      } else if (error?.response?.data?.message) {
        return rejectWithValue({
          message: error?.response?.data?.message,
        });
      }
    }
  }
);
export const sendCoins = createAsyncThunk(
  "performance/sendCoins",
  async ({ userId, coins , category }, { rejectWithValue, getState }) => {
    const { auth } = getState();
    try {
      const response = await axios.post(
        `${baseURL}/category/send-coins`,
        { user_id: userId, coins },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth?.token}`,
          },
        }
      );

      const data = response.data;
      if (data.error) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      if (error?.response?.data?.error) {
        return rejectWithValue({
          message: error?.response?.data?.error,
        });
      } else if (error?.response?.data?.message) {
        return rejectWithValue({
          message: error?.response?.data?.message,
        });
      }
    }
  }
);

const initialState = {
  loading: false,
  SendCoinsloading: false,
  error: null,
  livesDetails: {},
  transactionsData: [],
  categoryDetails: {},
  coinsAdded: false,
  targetAdded: false,
  targetDeleted: false,
  targetUpdated: false,
};

const performanceSlice = createSlice({
  name: "performance",
  initialState,
  reducers: {
    reset(state) {
      state.loading = false;
      state.SendCoinsloading = false;
      state.error = null;
      state.targetAdded = false;
      state.targetDeleted = false;
      state.targetUpdated = false;
      state.coinsAdded = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addTarget.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addTarget.fulfilled, (state, action) => {
        state.loading = false;
        state.targetAdded = true;
        state.error = null;
      })
      .addCase(addTarget.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      })
      .addCase(updateTarget.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTarget.fulfilled, (state, action) => {
        state.loading = false;
        state.targetUpdated = true;
        state.error = null;
      })
      .addCase(updateTarget.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      })
      .addCase(deleteTargetCat.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTargetCat.fulfilled, (state, action) => {
        state.loading = false;
        state.targetDeleted = true;
        state.error = null;
      })
      .addCase(deleteTargetCat.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      })
      .addCase(listTargets.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listTargets.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryDetails = action?.payload;
        state.error = null;
      })
      .addCase(listTargets.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      })
      .addCase(getTransactions.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.transactionsData = action?.payload;
        state.error = null;
      })
      .addCase(getTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      })
      .addCase(sendCoins.pending, (state, action) => {
        state.SendCoinsloading = true;
        state.error = null;
      })
      .addCase(sendCoins.fulfilled, (state, action) => {
        state.SendCoinsloading = false;
        state.coinsAdded = true;
        state.error = null;
      })
      .addCase(sendCoins.rejected, (state, action) => {
        state.SendCoinsloading = false;
        state.error = action?.payload?.message;
      });
  },
});

export const { reset } = performanceSlice.actions;
const performanceReducer = performanceSlice.reducer;

export default performanceReducer;
